module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-pdf-5387ca10.svg";